import { createFileRoute } from "@tanstack/react-router"
import { ForgotPassword } from "modules/auth/components/ForgotPassword"

export const Route = createFileRoute("/_base/_public/forgot-password")({
  component: ForgotPassword,
})
